import $ from 'jquery';
import _ from 'lodash';

export default function (form, opts) {
    opts = opts || {};

    var input = function (name) {
        return form.find('[name=' + name + ']');
    };

    var inputs = function (names) {
        var self = this,
            result = $();
        _.each(names, function (name) {
            result = result.add(input(name));
        });
        return result;
    };

    var group = function (name) {
        return input(name).parents('.form-group');
    };

    var groups = function (names) {
        return inputs(names).parents('.form-group');
    };

    var clearOptions = function (parent, placeholder) {
        parent.find('option').remove();
        if (placeholder) {
            addOption(parent, '', placeholder, true);
        }
    };

    var addOption = function (parent, value, name, isPlaceholder) {
        var extra = '';
        if (isPlaceholder)
            extra = ' selected disabled';

        var html = '<option value="' + value + '"' + extra + '>' +
                name +
                '</option>';

        $(html).appendTo(parent);
    };

    // Initialize the form
    if (!opts.noReset) {
        var selector = opts.resetSelector || 'button.reset';
        form.find(selector).on('click', function () {
            form.clearForm();
        });
    }

    return {
        input: input,
        inputs: inputs,
        group: group,
        groups: groups,
        clearOptions: clearOptions,
        addOption: addOption
    };
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/forms/base.js
 **/